'use strict';

export default function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('speechdetailses', {
        url: '/speechdetailses',
        template: '<speechdetailses></speechdetailses>'
    });
}



// WEBPACK FOOTER //
// ./client/app/speechdetailses/speechdetailses.routes.js